import {
  Autocomplete,
  Box,
  Button,
  Grid,
  IconButton,
  Link,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import "./index.scss";
import { useEffect, useState } from "react";
import FileUpload from "../../../../common-utilities/core/file-uploader";
import {
  HOSTNAME,
  INVOICE_TRACKING_HOSTNAME,
} from "../../../../common-utilities/utils/end-points";
import { REST_URLS } from "../../../../common-utilities/utils/end-points/invoice-tracking";
import { HTTP_METHODS, invokeApi } from "../../../utils/http-service";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { ArrowBack, CancelOutlined } from "@mui/icons-material";
import { FIELD_TYPES_MAP } from "../../master-data/item-list/helper";
import { formatPayload } from "./helper";

const CreateLegalDocument = () => {
  const [formDetails, setFormDetails] = useState({});
  const [vendorList, setVendorList] = useState({});
  const [vendorInputValue, setVendorInputValue] = useState("");
  const [fieldTypes, setFieldTypes] = useState({
    actionable: [],
    documentType: [],
    typeOfVendor: [],
    uploadAgreement: [],
  });
  const navigate = useNavigate();

  useEffect(() => {
    loadData();
  }, []);

  const onChange = (e) => {
    setFormDetails({
      ...formDetails,
      [e.target.name]: e.target.value,
    });
  };

  const loadData = () => {
    invokeApi(
      HTTP_METHODS.GET,
      `${INVOICE_TRACKING_HOSTNAME}${REST_URLS.LEGAL_FIELDS}`,
      null,
      { page: 1, limit: 100 }
    )
      .then((response) => {
        if (response.message) {
        } else if (response?.results?.length > 0) {
          setFieldTypes({
            actionable: response?.results
              .filter((r) => r.fieldType === FIELD_TYPES_MAP.actionable)
              .map((r) => r.title),
            documentType: response?.results
              .filter((r) => r.fieldType === FIELD_TYPES_MAP.documentType)
              .map((r) => r.title),
            typeOfVendor: response?.results
              .filter((r) => r.fieldType === FIELD_TYPES_MAP.typeOfVendor)
              .map((r) => r.title),
            uploadAgreement: response?.results
              .filter((r) => r.fieldType === FIELD_TYPES_MAP.uploadAgreement)
              .map((r) => r.title),
          });
        }
      })
      .catch((err) => {});
    invokeApi(
      HTTP_METHODS.GET,
      `${INVOICE_TRACKING_HOSTNAME}${REST_URLS.VENDOR_LIST}`
    )
      .then((response) => {
        if (response.code) {
        } else {
          setVendorList(response || []);
        }
      })
      .catch((err) => {});
  };

  const create = () => {
    invokeApi(
      HTTP_METHODS.POST,
      `${INVOICE_TRACKING_HOSTNAME}${REST_URLS.LEGAL_DOCUMENT}`,
      formatPayload(formDetails)
    )
      .then((response) => {
        if (response.id) {
          navigate(-1);
        } else {
          toast.error(response?.message || "Failed to create", {
            autoClose: 2000,
          });
        }
      })
      .catch((err) => {
        toast.error(err?.message || "Failed to create", { autoClose: 2000 });
      });
  };

  return (
    <Box sx={{ margin: 2 }}>
      <Stack direction="row" spacing={2} alignItems="center" sx={{ mb: 2 }}>
        <IconButton onClick={() => navigate(-1)}>
          <ArrowBack />
        </IconButton>
        <Typography className="title">Create Legal Document</Typography>
      </Stack>

      <Grid container spacing={2}>
        <Grid item xs={3}>
          <Autocomplete
            value={formDetails.actionable || ""}
            onChange={(e, val) => {
              if (val) {
                setFormDetails({ ...formDetails, actionable: val });
              } else {
                setFormDetails({});
              }
            }}
            renderInput={(params) => (
              <TextField {...params} size="small" label="Actionable *" />
            )}
            options={fieldTypes.actionable || []}
          />
        </Grid>
        <Grid item xs={3}>
          <Autocomplete
            value={formDetails.documentType || ""}
            onChange={(e, val) => {
              if (val) {
                setFormDetails({ ...formDetails, documentType: val });
              } else {
                setFormDetails({});
              }
            }}
            renderInput={(params) => (
              <TextField {...params} size="small" label="Document Type *" />
            )}
            options={fieldTypes.documentType || []}
          />
        </Grid>
        <Grid item xs={3}>
          <Autocomplete
            value={formDetails.typeOfVendor || ""}
            onChange={(e, val) => {
              if (val) {
                setFormDetails({ ...formDetails, typeOfVendor: val });
              } else {
                setFormDetails({});
              }
            }}
            renderInput={(params) => (
              <TextField {...params} size="small" label="Vendor Type *" />
            )}
            options={fieldTypes.typeOfVendor || []}
          />
        </Grid>
        {formDetails?.typeOfVendor === "Existing" ? (
          <Grid item xs={3}>
            <Autocomplete
              options={vendorList}
              renderInput={(params) => (
                <TextField {...params} size="small" label="Vendor" />
              )}
              getOptionLabel={(op) => op.name}
              inputValue={vendorInputValue}
              onInputChange={(event, newInputValue) => {
                if (event) {
                  setVendorInputValue(newInputValue);
                }
              }}
              value={formDetails.vendor || ""}
              onChange={(e, val) => {
                setFormDetails({
                  ...formDetails,
                  vendor: val,
                });
              }}
            />
          </Grid>
        ) : (
          <>
            <Grid item xs={3}>
              <TextField
                label="Vendor Name"
                value={formDetails.nameOfVendor}
                name="nameOfVendor"
                size="small"
                onChange={onChange}
                fullWidth
              />
            </Grid>
            <Grid item xs={3}>
              <TextField
                label="Vendor Address"
                value={formDetails.addressOfVendor}
                name="addressOfVendor"
                size="small"
                onChange={onChange}
                fullWidth
              />
            </Grid>
            <Grid item xs={3}>
              <TextField
                label="Vendor Email"
                value={formDetails.emailIdOfVendor}
                name="emailIdOfVendor"
                size="small"
                onChange={onChange}
                fullWidth
              />
            </Grid>
            <Grid item xs={3}>
              <TextField
                label="Vendor Business Description"
                value={formDetails.descriptionOfBusinessOfVendor}
                name="descriptionOfBusinessOfVendor"
                onChange={onChange}
                size="small"
                fullWidth
              />
            </Grid>
          </>
        )}
        <Grid item xs={3} hidden={formDetails?.typeOfVendor !== "New"}>
          <TextField
            label="Service Scope Description"
            value={formDetails.descriptionOfScopeOfService}
            name="descriptionOfScopeOfService"
            onChange={onChange}
            size="small"
            fullWidth
          />
        </Grid>
        <Grid item xs={3} hidden={formDetails?.typeOfVendor !== "New"}>
          <TextField
            label="Commercials breakup"
            value={formDetails.breakupOfCommercials}
            name="breakupOfCommercials"
            onChange={onChange}
            size="small"
            fullWidth
          />
        </Grid>
        <Grid item xs={3} hidden={formDetails?.typeOfVendor !== "New"}>
          <TextField
            label="Submission invoice payment time"
            value={formDetails.timeForPaymentOfInvoiceSubmission}
            name="timeForPaymentOfInvoiceSubmission"
            onChange={onChange}
            size="small"
            fullWidth
          />
        </Grid>
      </Grid>
      <Grid container spacing={2} sx={{ mt: 1 }}>
        <Grid item xs={3} hidden={formDetails?.typeOfVendor !== "New"}>
          <UploadView
            id="panCard"
            uploadText="PanCard"
            setFormDetails={setFormDetails}
            formDetails={formDetails}
          />
        </Grid>
        <Grid item xs={3} hidden={formDetails?.typeOfVendor !== "New"}>
          <UploadView
            id="aadharUpload"
            uploadText="Aadhar Card"
            formDetails={formDetails}
            setFormDetails={setFormDetails}
          />
        </Grid>
        <Grid item xs={3} hidden={formDetails?.typeOfVendor !== "New"}>
          <UploadView
            id="gstCertificate"
            uploadText="GST Certificate"
            setFormDetails={setFormDetails}
            formDetails={formDetails}
          />
        </Grid>
        <Grid item xs={3}>
          <UploadView
            id="originalAgreement"
            uploadText="Original Agreement"
            setFormDetails={setFormDetails}
            formDetails={formDetails}
          />
        </Grid>
        <Grid item xs={3}>
          <UploadView
            id="supportingDocument1"
            uploadText="Supporting Document 1"
            setFormDetails={setFormDetails}
            formDetails={formDetails}
          />
        </Grid>
        <Grid item xs={3}>
          <UploadView
            id="supportingDocument2"
            uploadText="Supporting Document 2"
            setFormDetails={setFormDetails}
            formDetails={formDetails}
          />
        </Grid>
      </Grid>
      <Stack alignItems="end">
        <Button variant="contained" sx={{ mt: 2 }} onClick={create}>
          Create
        </Button>
      </Stack>
    </Box>
  );
};

const UploadView = ({ id, uploadText, setFormDetails, formDetails }) => {
  if (formDetails[id]) {
    return (
      <Stack direction={"row"} alignItems="center" spacing={2}>
        <Link href={formDetails[id]} target="_blank">
          {uploadText}
        </Link>
        <IconButton
          onClick={() => {
            setFormDetails({
              ...formDetails,
              [id]: null,
            });
          }}
        >
          <CancelOutlined color="red" />
        </IconButton>
      </Stack>
    );
  }
  return (
    <FileUpload
      id={id}
      buttonBackground="#fff"
      buttonColor="#008938"
      mainButtonClass="subway-finance-bulk-upload"
      borderColor="rgba(0, 138, 82, 0.5)"
      uploadText={uploadText}
      clsName="subway-lg-upload"
      url={`${HOSTNAME}${REST_URLS.UPLOAD_DOCUMENT}`}
      formDataKey="upload"
      callBack={(response) => {
        const { data } = response;
        setFormDetails({
          ...formDetails,
          [id]: data.url,
        });
      }}
    />
  );
};

export default CreateLegalDocument;
